import { Component, ElementRef, OnInit, ViewChild, inject, signal } from '@angular/core'
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap'
import { AppointmentCardComponent } from '../appointment-card/appointment-card.component'
import { AppointmentStore } from 'src/app/shared/stores/appointment.store'
import { NgSelectModule } from '@ng-select/ng-select'
import { AppStore } from 'src/app/core/app.store'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { StaffListItem } from 'src/app/shared/interfaces/staff/staff-list-item.interface'
import { FormsModule } from '@angular/forms'
import { PaginationDetailComponent } from '../../pagination-detail/pagination-detail.component'
import { EmptyComponent } from '../../empty/empty.component'

@Component({
    selector: 'sf-pending-appointments-pullout',
    imports: [
        FormsModule,
        NgSelectModule,
        ButtonComponent,
        PaginationDetailComponent,
        AppointmentCardComponent,
        EmptyComponent,
    ],
    templateUrl: './pending-appointments-pullout.component.html',
    styleUrl: './pending-appointments-pullout.component.scss',
    providers: [AppointmentStore]
})
export class PendingAppointmentsPulloutComponent implements OnInit {
    activeOffcanvas = inject(NgbActiveOffcanvas)

    appStore = inject(AppStore)
    appointmentStore = inject(AppointmentStore)

    @ViewChild('header')
    header!: ElementRef

    selectedStaffId: number | null = null

    ngOnInit(): void {
        const me = this.appStore.me()

        if (me) {
            this.selectedStaffId = me.id
            this.appointmentStore.updateFilter({ staffId: me.id })
        }

        this.appointmentStore.loadByQuery(this.appointmentStore.filter)
    }

    onPageChange(page: number): void {
        this.appointmentStore.updateFilter({ pageNumber: page })
        this.header.nativeElement.scrollIntoView({ behavior: 'smooth' })
    }

    onSelectStaff(staff: StaffListItem): void {
        this.selectedStaffId = staff.id
        this.appointmentStore.updateFilter({ staffId: staff.id })
    }

    selectMe(): void {
        const me = this.appStore.me()

        if (me) {
            this.selectedStaffId = me.id
            this.appointmentStore.updateFilter({ staffId: me.id })
        }
    }
}
